var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "manifest-info" },
    [
      _c(
        "el-form",
        {
          ref: "myForm",
          attrs: {
            model: _vm.form,
            disabled: !_vm.isEdit,
            "label-width": "120px",
            "label-position": "right",
            rules: _vm.rules
          }
        },
        [
          _c(
            "el-form-item",
            { class: _vm.labelStyle, attrs: { label: "MB/L NO", prop: "mbl" } },
            [
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t(
                          "CargoMsg.Cargo_canOnlyBeUppercaseCharactersAndNumbers"
                        ),
                        placement: "bottom",
                        effect: "light"
                      }
                    },
                    [
                      _c("el-input", {
                        ref: "mbl",
                        staticClass: "short",
                        attrs: {
                          placeholder:
                            (_vm.isSeaHouseChannel ||
                              _vm.isWseChannel ||
                              _vm.isRongeTong) &&
                            _vm.isEdit
                              ? _vm.$t(
                                  "CargoMsg.Cargo_canOnlyBeUppercaseCharactersAndNumbers"
                                )
                              : "",
                          disabled:
                            (_vm.isSeaHouseChannel ||
                              _vm.isWseChannel ||
                              _vm.isRongeTong) &&
                            _vm.isSent
                        },
                        on: { blur: _vm.mblCheck, change: _vm.mblCheck },
                        model: {
                          value: _vm.form.mblNo,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "mblNo", $$v)
                          },
                          expression: "form.mblNo"
                        }
                      })
                    ],
                    1
                  ),
                  _c("img", {
                    staticStyle: {
                      height: "28px",
                      "margin-left": "5px",
                      cursor: "pointer"
                    },
                    attrs: { src: require("@/assets/icons/log.png") },
                    on: { click: _vm.handleReceipt }
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "el-form-item",
            {
              class: _vm.labelStyle,
              attrs: { label: _vm.$t("SeaExport.Vessel"), prop: "bargeVessel" }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t(
                      "CargoMsg.Cargo_pleaseEnterTheNameOfTheShipOnlyUppercaseCharactersAndNumbers"
                    ),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    class: _vm.importDifferenceField.bargeVessel
                      ? "red-border"
                      : "",
                    attrs: {
                      disabled:
                        (_vm.isSeaHouseChannel ||
                          _vm.isWseChannel ||
                          _vm.isRongeTong) &&
                        _vm.isSent,
                      "select-type": _vm.selectTypeNames.static_data_Vessel,
                      filterable: "",
                      "default-value": _vm.form.bargeVessel,
                      "static-options": _vm.vesselList,
                      "allow-create": true,
                      placeholder:
                        _vm.isSeaHouseChannel ||
                        _vm.isWseChannel ||
                        _vm.isRongeTong
                          ? _vm.$t(
                              "CargoMsg.Cargo_pleaseEnterTheNameOfTheShipOnlyUppercaseCharactersAndNumbers"
                            )
                          : ""
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.onVesselSelectionChange(p)
                        _vm.vesselCheck()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              class: _vm.labelStyle,
              attrs: { label: _vm.$t("SeaExport.Voyage"), prop: "voyage" }
            },
            [
              _c("cargo-advance-select", {
                ref: "voyageFlight",
                class: _vm.importDifferenceField.bargeVoyage
                  ? "red-border"
                  : "",
                attrs: {
                  disabled:
                    (_vm.isSeaHouseChannel ||
                      _vm.isWseChannel ||
                      _vm.isRongeTong) &&
                    _vm.isSent,
                  "static-options": _vm.optionsVoyages || [],
                  cache: false,
                  "default-value": _vm.form.bargeVoyage,
                  filterable: "",
                  clearable: "",
                  "allow-create": _vm.editVoyageMode,
                  "filter-tag-names": ["voyageNo"],
                  "tag-name": "voyageNo",
                  "tag-value": "voyageNo",
                  placeholder:
                    _vm.isSeaHouseChannel || _vm.isWseChannel || _vm.isRongeTong
                      ? _vm.$t("CargoMsg.Cargo_enterTheVoyageThereCanBeNoV")
                      : _vm.$t("CargoMsg.Cargo_inputVoyage")
                },
                on: {
                  focus: _vm.txtVoyageFocusInHandler,
                  parentCallBack: _vm.onVoyageFlightChange
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.isSeaHouseChannel &&
                    !_vm.isWseChannel &&
                    !_vm.isRongeTong,
                  expression:
                    "!isSeaHouseChannel && !isWseChannel && !isRongeTong"
                }
              ],
              class: _vm.labelStyle,
              attrs: { label: _vm.$t("SeaExport.ShippingCompany") }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t(
                      "CargoMsg.Cargo_enterTheVoyageThereCanBeNoV"
                    ),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-company-select", {
                    class: _vm.importDifferenceField.shippingCompany
                      ? "red-border"
                      : "",
                    attrs: {
                      filterable: "",
                      disabled: _vm.isSeaHouseChannel && _vm.isSent,
                      "method-params": { seaCmp: true },
                      "select-type": _vm.selectTypeNames.basic_data_Company,
                      "default-value": _vm.form.shippingCompany || "",
                      "allow-create": false
                    },
                    on: {
                      change: function(p) {
                        return (_vm.form.shippingCompany = p.value)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.isSeaHouseChannel ||
                    _vm.isWseChannel ||
                    _vm.isRongeTong,
                  expression: "isSeaHouseChannel || isWseChannel || isRongeTong"
                }
              ],
              class: _vm.labelStyle,
              attrs: {
                label: _vm.$t("SeaExport.ShippingCompany"),
                prop: "thirdPartyCarrier"
              }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t(
                      "CargoMsg.Cargo_pleaseSelectAShippingCompany"
                    ),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled: _vm.isSent,
                      "static-options": _vm.getOptions("carrierCompanyList"),
                      cache: false,
                      "default-value": _vm.form.thirdPartyCarrier,
                      filterable: "",
                      clearable: "",
                      "filter-tag-names": ["name", "code", "chineseName"],
                      "tag-name": "name",
                      "tag-value": "code",
                      placeholder: _vm.$t(
                        "SeaExport.PleaseSelectShippingCompany"
                      )
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.thirdPartyCarrier = p.value
                        _vm.changeThirdPartyCarrier()
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.isSeaHouseChannel &&
                    !_vm.isWseChannel &&
                    !_vm.isRongeTong,
                  expression:
                    "!isSeaHouseChannel && !isWseChannel && !isRongeTong"
                }
              ],
              class: _vm.labelStyle,
              attrs: { label: _vm.$t("SeaExport.CarrierAgent") }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t(
                      "CargoMsg.Cargo_pleaseSelectAShippingGeneration"
                    ),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-company-select", {
                    class: _vm.importDifferenceField.carrierAgent
                      ? "red-border"
                      : "",
                    attrs: {
                      disabled: _vm.isSeaHouseChannel && _vm.isSent,
                      "method-params": {
                        seaCmpAgent: true,
                        companyLob: "seaExport",
                        active: true
                      },
                      "default-value": _vm.form.carrierAgent,
                      "allow-create": false
                    },
                    on: {
                      change: function(p) {
                        _vm.form.carrierAgent = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.isSeaHouseChannel ||
                    _vm.isWseChannel ||
                    _vm.isRongeTong,
                  expression: "isSeaHouseChannel || isWseChannel || isRongeTong"
                }
              ],
              class: _vm.labelStyle,
              attrs: {
                label: _vm.$t("SeaExport.CarrierAgent"),
                prop: "thirdPartyCarrierAgent"
              }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t(
                      "CargoMsg.Cargo_pleaseSelectAShippingGeneration"
                    ),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled: _vm.isSent,
                      "static-options": _vm.getOptions(
                        "carrierAgentCompanyList"
                      ),
                      cache: false,
                      "default-value": _vm.form.thirdPartyCarrierAgent,
                      filterable: "",
                      clearable: "",
                      "filter-tag-names": ["name", "code", "chineseName"],
                      "tag-name": "name",
                      "tag-value": "code",
                      placeholder: _vm.$t(
                        "CargoMsg.Cargo_pleaseSelectAShippingGeneration"
                      )
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.thirdPartyCarrierAgent = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.isSeaHouseChannel &&
                    !_vm.isWseChannel &&
                    !_vm.isRongeTong,
                  expression:
                    "!isSeaHouseChannel && !isWseChannel && !isRongeTong"
                }
              ],
              class: _vm.labelStyle,
              attrs: { label: _vm.$t("SeaExport.PortOfLoadingAI") }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("CargoMsg.Cargo_PortOfLoadingTip"),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    class: _vm.importDifferenceField.portOfLoading
                      ? "red-border"
                      : "",
                    attrs: {
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.form.portOfLoading,
                      "tag-name": "englishName"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.portOfLoading = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.isSeaHouseChannel ||
                    _vm.isWseChannel ||
                    _vm.isRongeTong,
                  expression: "isSeaHouseChannel || isWseChannel || isRongeTong"
                }
              ],
              class: _vm.labelStyle,
              attrs: {
                label: _vm.$t("SeaExport.PortOfLoadingAI"),
                prop: "portOfLoading"
              }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("CargoMsg.Cargo_PortOfLoadingTip"),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      disabled:
                        (_vm.isSeaHouseChannel ||
                          _vm.isWseChannel ||
                          _vm.isRongeTong) &&
                        _vm.isSent,
                      "static-options": _vm.getOptions("portOfLoadingSeaports"),
                      filterable: "",
                      cache: false,
                      "default-value": _vm.form.portOfLoading,
                      "tag-name": "name",
                      "tag-value": "code",
                      "filter-tag-names": ["name", "code"],
                      placeholder: _vm.$t("CargoMsg.Cargo_PortOfLoadingTip"),
                      "custom-label": function(item) {
                        return item ? item.name + "|" + item.code : ""
                      }
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.portOfLoadingHandler(p)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.isSeaHouseChannel &&
                    !_vm.isWseChannel &&
                    !_vm.isRongeTong,
                  expression:
                    "!isSeaHouseChannel && !isWseChannel && !isRongeTong"
                }
              ],
              class: _vm.labelStyle,
              attrs: { label: _vm.$t("CargoMsg.Cargo_PortOfDischarge") }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("CargoMsg.Cargo_PortOfDischargeTipText"),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    class: _vm.importDifferenceField.portOfDischarge
                      ? "red-border"
                      : "",
                    attrs: {
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.form.portOfDischarge
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.portOfDischarge = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.isSeaHouseChannel ||
                    _vm.isWseChannel ||
                    _vm.isRongeTong,
                  expression: "isSeaHouseChannel || isWseChannel || isRongeTong"
                }
              ],
              class: _vm.labelStyle,
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_PortOfDischarge"),
                prop: "portOfDischarge"
              }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("CargoMsg.Cargo_PortOfDischargeTipText"),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      "static-options": _vm.isOocl
                        ? _vm.getOptions("ooclSeaports")
                        : _vm.getOptions("seaports"),
                      filterable: "",
                      cache: false,
                      "default-value": _vm.form.portOfDischarge,
                      "tag-name": "name",
                      "tag-value": "code",
                      "filter-tag-names": ["name", "code"],
                      "custom-label": function(item) {
                        return item ? item.name + "|" + item.code : ""
                      },
                      placeholder: _vm.$t(
                        "CargoMsg.Cargo_PortOfDischargeTipText"
                      )
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.portOfDischarge = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.isSeaHouseChannel &&
                    !_vm.isWseChannel &&
                    !_vm.isRongeTong,
                  expression:
                    "!isSeaHouseChannel && !isWseChannel && !isRongeTong"
                }
              ],
              class: _vm.labelStyle,
              attrs: { label: _vm.$t("SeaExport.PortOfDestination") }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("CargoMsg.Cargo_PortOfDestinationTip2"),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    class: _vm.importDifferenceField.portOfDestination
                      ? "red-border"
                      : "",
                    attrs: {
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.form.portOfDestination
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.portOfDestination = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.isSeaHouseChannel ||
                    _vm.isWseChannel ||
                    _vm.isRongeTong,
                  expression: "isSeaHouseChannel || isWseChannel || isRongeTong"
                }
              ],
              class: _vm.labelStyle,
              attrs: {
                label: _vm.$t("SeaExport.PortOfDestination"),
                prop: "portOfDestination"
              }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("CargoMsg.Cargo_PortOfDestinationTip2"),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      "static-options": _vm.getOptions("seaports"),
                      filterable: "",
                      cache: false,
                      "default-value": _vm.form.portOfDestination,
                      "tag-name": "name",
                      "tag-value": "code",
                      "filter-tag-names": ["name", "code"],
                      "custom-label": function(item) {
                        return item ? item.name + "|" + item.code : ""
                      },
                      placeholder: _vm.$t(
                        "CargoMsg.Cargo_PortOfDestinationTip2"
                      )
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.portOfDestination = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.isSeaHouseChannel &&
                    !_vm.isWseChannel &&
                    !_vm.isRongeTong,
                  expression:
                    "!isSeaHouseChannel && !isWseChannel && !isRongeTong"
                }
              ],
              class: _vm.labelStyle,
              attrs: { label: _vm.$t("SeaExport.CargoType") }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t(
                      "CargoMsg.Cargo_pleaseSelectTheTypeOfGoods"
                    ),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    class: _vm.importDifferenceField.cargoType
                      ? "red-border"
                      : "",
                    attrs: {
                      "select-type": _vm.selectTypeNames.basic_data_CargoType,
                      "method-params": { sea: true },
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.form.cargoType
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.cargoType = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.isSeaHouseChannel ||
                    _vm.isWseChannel ||
                    _vm.isRongeTong,
                  expression: "isSeaHouseChannel || isWseChannel || isRongeTong"
                }
              ],
              class: _vm.labelStyle,
              attrs: { label: _vm.$t("SeaExport.CargoType"), prop: "cargoType" }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t(
                      "CargoMsg.Cargo_pleaseSelectTheTypeOfGoods"
                    ),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      "static-options": _vm.getOptions("cargoTypes"),
                      cache: false,
                      "default-value": _vm.form.thirdPartyCargoType,
                      filterable: "",
                      "filter-tag-names": ["name", "code", "chineseName"],
                      "tag-name": "name",
                      "tag-value": "code",
                      placeholder: _vm.$t(
                        "CargoMsg.Cargo_pleaseSelectTheTypeOfGoods"
                      )
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.thirdPartyCargoType = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !(
                    _vm.isWseChannel ||
                    _vm.isSeaHouseChannel ||
                    (_vm.isRongeTong && _vm.isShangHai)
                  ),
                  expression:
                    "!(isWseChannel || isSeaHouseChannel || (isRongeTong && isShangHai))"
                }
              ],
              class: _vm.labelStyle,
              attrs: { label: _vm.$t("SeaExport.TransportationClause") }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("CargoMsg.Cargo_InputBLFreightTermTootip"),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.isSent && !_vm.isWseChannel && !_vm.isRongeTong,
                        expression: "isSent && !isWseChannel && !isRongeTong"
                      }
                    ],
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.form.masterBLFreightTermTootip,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "masterBLFreightTermTootip", $$v)
                      },
                      expression: "form.masterBLFreightTermTootip"
                    }
                  }),
                  _c("cargo-advance-select", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          !(
                            _vm.isSeaHouseChannel ||
                            _vm.isWseChannel ||
                            _vm.isRongeTong
                          ) && !_vm.isSent,
                        expression:
                          "!(isSeaHouseChannel || isWseChannel || isRongeTong) && !isSent"
                      }
                    ],
                    class: _vm.importDifferenceField.masterBLFreightTermTootip
                      ? "red-border"
                      : "",
                    attrs: {
                      "select-type":
                        _vm.selectTypeNames.basic_data_ShippingTerm,
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.form.masterBLFreightTermTootip
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.masterBLFreightTermTootip = p.value
                      }
                    }
                  }),
                  _c("cargo-advance-select", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.isSeaHouseChannel ||
                          (_vm.isRongeTong && !_vm.isShangHai),
                        expression:
                          "isSeaHouseChannel || (isRongeTong && !isShangHai)"
                      }
                    ],
                    attrs: {
                      disabled: _vm.isSeaHouseChannel,
                      "static-options": _vm.getOptions("shippingTerms"),
                      cache: false,
                      "default-value": _vm.form.thirdPartyFreightTerm,
                      filterable: "",
                      "filter-tag-names": ["name", "code", "chineseName"],
                      "tag-name": "name",
                      "tag-value": "code"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.thirdPartyFreightTerm = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !(
                    _vm.isSeaHouseChannel ||
                    _vm.isWseChannel ||
                    _vm.isRongeTong
                  ),
                  expression: "!(isSeaHouseChannel||isWseChannel||isRongeTong)"
                }
              ],
              class: _vm.labelStyleExcludeWse,
              attrs: { label: _vm.$t("SeaExport.FreightTerm") }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("CargoMsg.Cargo_pleaseSelectShippingTerms"),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    class: _vm.importDifferenceField.masterBLFreightTerm
                      ? "red-border"
                      : "",
                    attrs: {
                      "select-type": _vm.selectTypeNames.basic_data_PaymentTerm,
                      filterable: "",
                      clearable: false,
                      "default-value": _vm.form.masterBLFreightTerm
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.masterBLFreightTerm = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.isSeaHouseChannel ||
                    _vm.isWseChannel ||
                    _vm.isRongeTong,
                  expression: "isSeaHouseChannel || isWseChannel || isRongeTong"
                }
              ],
              class: _vm.labelStyle,
              attrs: {
                label: _vm.$t("SeaExport.FreightTerm"),
                prop: "thirdPartyPaymentMethod"
              }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("CargoMsg.Cargo_pleaseSelectShippingTerms"),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    attrs: {
                      "static-options": _vm.getOptions("paymentTerms"),
                      cache: false,
                      "default-value": _vm.form.thirdPartyPaymentMethod,
                      filterable: "",
                      "filter-tag-names": ["name", "code", "chineseName"],
                      "tag-name": "name",
                      "tag-value": "code",
                      placeholder: _vm.$t(
                        "CargoMsg.Cargo_pleaseSelectShippingTerms"
                      )
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.thirdPartyPaymentMethod = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              class:
                _vm.isWseChannel || _vm.isRongeTong ? "required-label" : "",
              attrs: {
                label: _vm.$t("SeaExport.DateOfDeparture"),
                prop: "sailingDate"
              }
            },
            [
              _c("el-date-picker", {
                class: _vm.importDifferenceField.sailingDate
                  ? "red-border"
                  : "",
                attrs: {
                  "sailing-date": "",
                  type: "date",
                  "value-format": "yyyy-MM-dd",
                  placeholder: _vm.$t("CargoMsg.Cargo_SailingDateTip")
                },
                model: {
                  value: _vm.form.sailingDate,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "sailingDate", $$v)
                  },
                  expression: "form.sailingDate"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              class: _vm.labelStyle,
              attrs: {
                label: _vm.$t("SeaExport.BlType"),
                prop: "thirdPartyBlType"
              }
            },
            [
              _c(
                "el-select",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !(
                        _vm.isSeaHouseChannel ||
                        _vm.isWseChannel ||
                        _vm.isRongeTong
                      ),
                      expression:
                        "!(isSeaHouseChannel|| isWseChannel || isRongeTong)"
                    }
                  ],
                  class: _vm.importDifferenceField.blType ? "red-border" : "",
                  on: {
                    change: function(val) {
                      _vm.cmbreleaseTypeMBLChangeHandler(val)
                    }
                  },
                  model: {
                    value: _vm.form.blType,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "blType", $$v)
                    },
                    expression: "form.blType"
                  }
                },
                _vm._l(_vm.blModeList, function(item) {
                  return _c("el-option", {
                    key: item.code,
                    attrs: { label: item.name, value: item.serialNumber }
                  })
                }),
                1
              ),
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("CargoMsg.Cargo_BlNumberTip"),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.isSeaHouseChannel ||
                          _vm.isWseChannel ||
                          _vm.isRongeTong,
                        expression:
                          "isSeaHouseChannel || isWseChannel || isRongeTong"
                      }
                    ],
                    attrs: {
                      "static-options": _vm.getOptions("blModeList"),
                      cache: false,
                      "default-value": _vm.form.thirdPartyBlType,
                      filterable: "",
                      "filter-tag-names": ["name", "code", "chineseName"],
                      "tag-name": "name",
                      "tag-value": "code",
                      placeholder: _vm.$t("CargoMsg.Cargo_BlNumberTip")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.thirdPartyBlType = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isWseChannel && !_vm.isSeaHouseChannel,
                  expression: "!isWseChannel&&!isSeaHouseChannel"
                }
              ],
              class: _vm.labelStyle,
              attrs: {
                label: _vm.$t("SeaExport.NoOfOriginalBls"),
                prop: "blNumber"
              }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("CargoMsg.Cargo_PureNumbers"),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("el-input", {
                    class: _vm.importDifferenceField.blNumber
                      ? "red-border"
                      : "",
                    attrs: {
                      placeholder:
                        _vm.isRongeTong && _vm.isEdit
                          ? _vm.$t("CargoMsg.Cargo_PureNumbers")
                          : ""
                    },
                    model: {
                      value: _vm.form.blNumber,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "blNumber", $$v)
                      },
                      expression: "form.blNumber"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.isWseChannel &&
                    !_vm.isSeaHouseChannel &&
                    !_vm.isRongeTong,
                  expression: "!isWseChannel&&!isSeaHouseChannel&&!isRongeTong"
                }
              ],
              attrs: { label: _vm.$t("SeaExport.PlaceOfPayment") }
            },
            [
              _c("el-input", {
                class: _vm.importDifferenceField.placeOfPayment
                  ? "red-border"
                  : "",
                attrs: {
                  placeholder:
                    (_vm.isSeaHouseChannel ||
                      _vm.isWseChannel ||
                      _vm.isRongeTong) &&
                    _vm.isEdit
                      ? _vm.$t(
                          "CargoMsg.Cargo_pleaseEnterTheFullEnglishNameOfThePortInCapitalLetters"
                        )
                      : ""
                },
                model: {
                  value: _vm.form.placeOfPayment,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "placeOfPayment", $$v)
                  },
                  expression: "form.placeOfPayment"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.isWseChannel &&
                    !_vm.isSeaHouseChannel &&
                    !_vm.isRongeTong,
                  expression:
                    "!isWseChannel && !isSeaHouseChannel && !isRongeTong"
                }
              ],
              class: _vm.labelStyleExcludeWse,
              attrs: { label: _vm.$t("SeaExport.PlaceOfIssue") }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("CargoMsg.Cargo_DefaultShanghai"),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.isSeaHouseChannel || _vm.isWseChannel
                    },
                    model: {
                      value: _vm.form.signPlaceBL,
                      callback: function($$v) {
                        _vm.$set(_vm.form, "signPlaceBL", $$v)
                      },
                      expression: "form.signPlaceBL"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("SeaExport.DateOfIssue") } },
            [
              _c("el-date-picker", {
                attrs: { type: "date", "value-format": "yyyy-MM-dd" },
                model: {
                  value: _vm.form.signDateBL,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "signDateBL", $$v)
                  },
                  expression: "form.signDateBL"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              class: _vm.labelStyle,
              attrs: {
                label: _vm.$t("SeaExport.PlaceOfReceipt"),
                prop: "dispatchingPlaceCode"
              }
            },
            [
              _c(
                "el-tooltip",
                {
                  attrs: {
                    content: _vm.$t("CargoMsg.Cargo_DispatchingPlaceCodeTip"),
                    placement: "bottom",
                    effect: "light"
                  }
                },
                [
                  _c("cargo-advance-select", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          !_vm.isSeaHouseChannel &&
                          !_vm.isWseChannel &&
                          !_vm.isRongeTong,
                        expression:
                          "!isSeaHouseChannel && !isWseChannel && !isRongeTong"
                      }
                    ],
                    class: _vm.importDifferenceField.dispatchingPlaceCode
                      ? "red-border"
                      : "",
                    attrs: {
                      "select-type": _vm.selectTypeNames.basic_data_Seaport,
                      filterable: "",
                      "default-value": _vm.form.dispatchingPlaceCode,
                      "tag-name": "englishName"
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.dispatchingPlaceCode = p.value
                      }
                    }
                  }),
                  _c("cargo-advance-select", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          _vm.isSeaHouseChannel ||
                          _vm.isWseChannel ||
                          _vm.isRongeTong,
                        expression:
                          "isSeaHouseChannel || isWseChannel || isRongeTong"
                      }
                    ],
                    class: _vm.importDifferenceField.dispatchingPlaceCode
                      ? "red-border"
                      : "",
                    attrs: {
                      "static-options": _vm.getOptions(
                        "placeOfDispatchSeaports"
                      ),
                      filterable: "",
                      cache: false,
                      "default-value": _vm.form.dispatchingPlaceCode,
                      "tag-name": "name",
                      "tag-value": "code",
                      "filter-tag-names": ["name", "code"],
                      "custom-label": function(item) {
                        return item ? item.name + "|" + item.code : ""
                      },
                      placeholder: _vm.$t(
                        "CargoMsg.Cargo_pleaseEnterTheFullEnglishNameOfThePortInCapitalLetters"
                      )
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.form.dispatchingPlaceCode = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.isWseChannel &&
                    _vm.isOocl &&
                    (_vm.isShangHai || _vm.isQingDao),
                  expression:
                    "isWseChannel && isOocl && (isShangHai || isQingDao)"
                }
              ],
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_IMO"),
                prop: "dispatchingImo"
              }
            },
            [
              _c("el-input", {
                attrs: { placeholder: "" },
                model: {
                  value: _vm.form.imo,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "imo", $$v)
                  },
                  expression: "form.imo"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }